import React from 'react';
import axios from 'axios';
import { Button, Card, Space, Table, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { FileApi, URL } from '../../../services/Api';
import { ROLE } from '../../../services/Macro';
import { FileItem } from './FileItem';

interface AppAllFilesProps {
    trans: (key: string) => string;
    fileList: FileItem[];
    notify: (message: string) => void;
    handleError: (title: string, info: string) => void;
    handleConfirm: (title: string, info: string, op: () => Promise<void> | void) => void;
    updateFileList: (upFm: boolean, upApp: boolean) => void;
}

export default class AppAllFiles4Pc extends React.Component<AppAllFilesProps> {
    deleteFile = (filename: string) => {
        const { trans: t, handleError, handleConfirm, notify, updateFileList } = this.props;
        const title = t('plsConfirm');
        const info = `确定要删除文件 ${filename}？`;

        const op = async () => {
            try {
                const token = localStorage.getItem('token') || '';
                const lang = localStorage.getItem('lang') || 'zh_CN';
                const role = localStorage.getItem('role') || ROLE.SUPER;

                const response = await axios.post(FileApi.SUPER_DEL, {
                    role,
                    token,
                    lang: lang.split('_')[0],
                    fileType: 'app',
                    fileName: filename,
                });

                if (response.data.code === 400) {
                    handleError(t('serverError'), response.data.message);
                    return;
                }

                notify(t('delSuccess'));
                updateFileList(false, true);
            } catch (error: any) {
                handleError(t('serverError'), error?.response?.data?.message || error?.message || String(error));
            }
        };

        handleConfirm(title, info, op);
    };

    getUrl = (item: FileItem) => {
        const href = `${URL}/app/${item.fileName}`;
        return item.openInNewTab ? (
            <a href={href} target="_blank" rel="noreferrer">{item.fileName}</a>
        ) : (
            <a href={href} download={item.fileName}>{item.fileName}</a>
        );
    };

    render() {
        const { trans: t, fileList } = this.props;

        const columns = [
            {
                title: t('fileName'),
                dataIndex: 'fileName',
                key: 'fileName',
                render: (_: string, item: FileItem) => this.getUrl(item),
            },
            {
                title: t('updateTime'),
                dataIndex: 'updateTime',
                key: 'updateTime',
            },
            {
                title: '',
                key: 'action',
                width: 80,
                align: 'center' as const,
                render: (_: unknown, item: FileItem) => (
                    <Button
                        danger
                        type="text"
                        icon={<DeleteOutlined />}
                        onClick={() => this.deleteFile(item.fileName)}
                    />
                ),
            },
        ];

        return (
            <Card title={t('pc') + t('appFile')} style={{ marginBottom: 16 }}>
                <Table<FileItem>
                    rowKey={(item) => item.fileName}
                    columns={columns}
                    dataSource={fileList}
                    pagination={false}
                    size="small"
                />
            </Card>
        );
    }
}
